import React, { useState } from 'react';

// 水晶辨别数据
const crystalData = [
  {
    id: 'amethyst',
    name: '紫水晶',
    hardness: 7,
    refractiveIndex: '1.544-1.553',
    identification: [
      '颜色从浅紫到深紫不等',
      '通常带有色带',
      '内部可能有裂纹或内含物',
      '玻璃光泽',
      '透明到半透明'
    ],
    imitations: [
      '合成紫水晶：颜色均匀，无天然色带',
      '玻璃仿制品：内部无天然内含物，气泡较多',
      '染色石英：颜色仅在表面，内部无色'
    ],
    image: 'https://via.placeholder.com/400x300/9c27b0/ffffff?text=紫水晶'
  },
  {
    id: 'rose-quartz',
    name: '玫瑰石英',
    hardness: 7,
    refractiveIndex: '1.544-1.553',
    identification: [
      '颜色从浅粉到深粉不等',
      '通常带有云雾状内含物',
      '玻璃光泽',
      '半透明到不透明',
      '无明显色带'
    ],
    imitations: [
      '合成玫瑰石英：颜色过于均匀',
      '染色石英：颜色仅在表面',
      '玻璃仿制品：内部无天然云雾状内含物'
    ],
    image: 'https://via.placeholder.com/400x300/e91e63/ffffff?text=玫瑰石英'
  },
  {
    id: 'citrine',
    name: '黄水晶',
    hardness: 7,
    refractiveIndex: '1.544-1.553',
    identification: [
      '颜色从浅黄到深黄不等',
      '通常带有色带',
      '玻璃光泽',
      '透明到半透明',
      '内部可能有裂纹或内含物'
    ],
    imitations: [
      '热处理紫水晶：颜色通常较淡，无天然色带',
      '合成黄水晶：颜色均匀',
      '玻璃仿制品：内部无天然内含物'
    ],
    image: 'https://via.placeholder.com/400x300/ffc107/ffffff?text=黄水晶'
  },
  {
    id: 'obsidian',
    name: '黑曜石',
    hardness: 5-5.5,
    refractiveIndex: '1.500',
    identification: [
      '颜色通常为黑色',
      '可能带有彩虹眼或金曜石效果',
      '玻璃光泽',
      '不透明',
      '断口呈贝壳状'
    ],
    imitations: [
      '玻璃仿制品：重量较轻，断口较锋利',
      '染色大理石：内部有明显纹理',
      '合成黑曜石：无天然彩虹眼效果'
    ],
    image: 'https://via.placeholder.com/400x300/212121/ffffff?text=黑曜石'
  },
  {
    id: 'clear-quartz',
    name: '白水晶',
    hardness: 7,
    refractiveIndex: '1.544-1.553',
    identification: [
      '无色透明',
      '玻璃光泽',
      '透明到半透明',
      '内部可能有裂纹或内含物',
      '双折射现象明显'
    ],
    imitations: [
      '玻璃仿制品：内部无天然内含物，气泡较多',
      '合成白水晶：颜色过于纯净',
      '塑料仿制品：比重较轻'
    ],
    image: 'https://via.placeholder.com/400x300/bdbdbd/ffffff?text=白水晶'
  }
];

const CrystalIdentification = () => {
  const [selectedCrystal, setSelectedCrystal] = useState(crystalData[0]);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');

  // 打开图片放大模态框
  const openImageModal = (image) => {
    setModalImage(image);
    setShowModal(true);
  };

  // 关闭图片放大模态框
  const closeImageModal = () => {
    setShowModal(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          水晶/宝石辨别小课堂
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* 水晶列表 */}
          <div className="md:col-span-1">
            <div className="bg-white rounded-xl shadow-lg p-4 border border-purple-100">
              <h2 className="text-xl font-semibold mb-4 text-purple-700 text-center">
                常见水晶
              </h2>
              <div className="space-y-2">
                {crystalData.map((crystal) => (
                  <button
                    key={crystal.id}
                    onClick={() => setSelectedCrystal(crystal)}
                    className={`w-full px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
                      selectedCrystal.id === crystal.id
                        ? 'bg-purple-100 text-purple-800 font-medium'
                        : 'bg-gray-50 text-gray-700 hover:bg-purple-50'
                    }`}
                  >
                    {crystal.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* 水晶详情 */}
          <div className="md:col-span-3">
            <div className="bg-white rounded-xl shadow-lg p-6 border border-purple-100">
              <div className="flex flex-col md:flex-row gap-6">
                {/* 水晶图片 */}
                <div className="md:w-1/3">
                  <div 
                    className="relative overflow-hidden rounded-lg cursor-pointer shadow-md"
                    onClick={() => openImageModal(selectedCrystal.image)}
                  >
                    <img
                      src={selectedCrystal.image}
                      alt={selectedCrystal.name}
                      className="w-full h-auto transition-transform duration-300 hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-200">
                      <span className="text-white font-medium">点击放大</span>
                    </div>
                  </div>
                  <div className="mt-4 bg-purple-50 rounded-lg p-4">
                    <h3 className="text-sm font-semibold text-purple-700 mb-2">基本参数</h3>
                    <ul className="text-sm space-y-1">
                      <li><strong>硬度：</strong>{selectedCrystal.hardness}</li>
                      <li><strong>折射率：</strong>{selectedCrystal.refractiveIndex}</li>
                    </ul>
                  </div>
                </div>

                {/* 水晶信息 */}
                <div className="md:w-2/3">
                  <h2 className="text-2xl font-bold mb-4 text-purple-800">
                    {selectedCrystal.name}
                  </h2>
                  
                  {/* 辨别要点 */}
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-3 text-purple-700 flex items-center">
                      <span className="mr-2">🔍</span> 辨别要点
                    </h3>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      {selectedCrystal.identification.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  </div>

                  {/* 常见假冒品 */}
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-purple-700 flex items-center">
                      <span className="mr-2">⚠️</span> 常见假冒品
                    </h3>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      {selectedCrystal.imitations.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 图片放大模态框 */}
      {showModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeImageModal}
        >
          <div className="relative max-w-4xl max-h-[90vh] p-4">
            <button
              className="absolute top-2 right-2 text-white text-2xl z-10"
              onClick={closeImageModal}
            >
              ×
            </button>
            <img
              src={modalImage}
              alt="放大图片"
              className="max-w-full max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CrystalIdentification;